// ----------------------------------------------------------------------
const ROOTS = {
  AUTH: '/auth',
  DASHBOARD: '/dashboard',
};

export const paths = {
  // AUTH
  auth: {
    jwt: {
      signIn: `${ROOTS.AUTH}/jwt/sign-in`,
      signUp: `${ROOTS.AUTH}/jwt/sign-up`,
    },
    firebase: {
      signIn: `${ROOTS.AUTH}/firebase/sign-in`,
      verify: `${ROOTS.AUTH}/firebase/verify`,
      signUp: `${ROOTS.AUTH}/firebase/sign-up`,
      resetPassword: `${ROOTS.AUTH}/firebase/reset-password`,
    },
  },
  // DASHBOARD
  dashboard: {
    root: ROOTS.DASHBOARD,
    project: `${ROOTS.DASHBOARD}/projects`,
    projectById: (projectId: string | number) => `${ROOTS.DASHBOARD}/projects/${projectId}`,
    user: `${ROOTS.DASHBOARD}/users`,
    userById: (userId: string | number) => `${ROOTS.DASHBOARD}/users/${userId}`,
  },
};
